const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNecklace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 336.001 336.001",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -1020.36)",
    shapeRendering: "auto",
    imageRendering: "auto",
    colorRendering: "auto",
    colorInterpolation: "sRGB"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#484666"
    },
    d: "M47.901,1076.34c-13.165,0-23.984,10.934-23.984,24.094c0,13.158,10.82,23.975,23.984,23.975 s24.103-10.816,24.103-23.975C72.004,1087.274,61.066,1076.34,47.901,1076.34z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93CFEF"
    },
    d: "M47.901,1092.403c4.515,0,8.034,3.518,8.034,8.031c0,4.51-3.52,7.912-8.034,7.912 c-4.515,0-7.916-3.398-7.916-7.912C39.985,1095.924,43.387,1092.403,47.901,1092.403z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#484666"
    },
    d: "M72.004,1124.409c-13.165,0-24.103,10.816-24.103,23.975c0,13.16,10.938,23.975,24.103,23.975 s23.984-10.814,23.984-23.975C95.988,1135.225,85.168,1124.409,72.004,1124.409z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93CFEF"
    },
    d: "M72.004,1140.352c4.515,0,7.916,3.52,7.916,8.031c0,4.512-3.402,8.031-7.916,8.031 c-4.515,0-8.034-3.52-8.034-8.031C63.97,1143.874,67.489,1140.352,72.004,1140.352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#484666"
    },
    d: "M111.939,1164.327c-13.164,0-23.984,10.934-23.984,24.094s10.82,23.975,23.984,23.975 s24.103-10.814,24.103-23.975C136.041,1175.262,125.103,1164.327,111.939,1164.327z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93CFEF"
    },
    d: "M111.939,1180.389c4.515,0,8.034,3.52,8.034,8.031s-3.52,7.914-8.034,7.914 c-4.515,0-7.916-3.398-7.916-7.914C104.023,1183.911,107.424,1180.389,111.939,1180.389z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#484666"
    },
    d: "M167.942,1188.419c-13.165,0-23.984,10.816-23.984,23.975c0,13.16,10.82,23.977,23.984,23.977 c13.165,0,24.103-10.816,24.103-23.977C192.044,1199.235,181.106,1188.419,167.942,1188.419L167.942,1188.419z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93CFEF"
    },
    d: "M167.942,1204.364c4.515,0,8.034,3.52,8.034,8.031s-3.52,8.031-8.034,8.031 c-4.515,0-7.916-3.52-7.916-8.031C160.026,1207.885,163.427,1204.364,167.942,1204.364L167.942,1204.364z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#484666"
    },
    d: "M287.982,1076.34c13.165,0,24.103,10.934,24.103,24.094c0,13.158-10.938,23.975-24.103,23.975 c-13.165,0-23.984-10.816-23.984-23.975C263.998,1087.274,274.818,1076.34,287.982,1076.34z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93CFEF"
    },
    d: "M287.982,1092.403c-4.515,0-7.916,3.518-7.916,8.031c0,4.51,3.401,7.912,7.916,7.912 c4.515,0,8.034-3.398,8.034-7.912C296.016,1095.924,292.497,1092.403,287.982,1092.403z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#484666"
    },
    d: "M263.998,1124.409c13.165,0,23.984,10.816,23.984,23.975c0,13.16-10.82,23.975-23.984,23.975 c-13.165,0-23.984-10.814-23.984-23.975C240.013,1135.225,250.833,1124.409,263.998,1124.409z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93CFEF"
    },
    d: "M263.998,1140.352c-4.515,0-7.916,3.52-7.916,8.031s3.402,8.031,7.916,8.031 c4.515,0,8.034-3.52,8.034-8.031C272.032,1143.874,268.512,1140.352,263.998,1140.352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#484666"
    },
    d: "M224.063,1164.327c13.165,0,23.984,10.934,23.984,24.094s-10.82,23.975-23.984,23.975 c-13.164,0-24.103-10.814-24.103-23.975C199.96,1175.262,210.898,1164.327,224.063,1164.327z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93CFEF"
    },
    d: "M224.063,1180.389c-4.515,0-8.034,3.52-8.034,8.031s3.52,7.914,8.034,7.914 c4.515,0,7.916-3.398,7.916-7.914C231.979,1183.911,228.577,1180.389,224.063,1180.389z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#484666"
    },
    d: "M140.058,1244.401c-19.584,0-36.019,15.463-36.036,34.721c0.01,9.701,4.625,18.51,9.216,25.629 c7.047,10.93,19.224,22.793,29.892,32.596s19.849,17.244,19.849,17.244c2.931,2.361,7.112,2.361,10.043,0 c0,0,9.178-7.439,19.849-17.244c10.671-9.801,22.85-21.656,29.892-32.596c4.391-6.82,9.2-15.42,9.216-25.746 c0.019-19.262-16.332-34.621-35.918-34.605c-17.082,0-24.128,10.783-28.002,15.473c-3.835-4.656-10.873-15.486-28.002-15.473 L140.058,1244.401z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D87070"
    },
    d: "M195.943,1260.344c14.224,0.416,18.773,9.633,20.086,18.66c-0.007,4.922-2.891,11.035-6.735,17.006 c-5.206,8.086-17.017,20.203-27.293,29.643c-7.543,6.93-10.897,9.641-13.942,12.164c-3.023-2.504-6.481-5.201-14.06-12.164 c-10.274-9.441-22.077-21.555-27.293-29.643c-3.623-5.617-6.731-13.52-6.735-16.889c0.009-10.174,8.735-18.648,20.086-18.66 c9.957-0.01,21.621,12.873,21.621,12.873c3.204,4.125,9.438,4.125,12.642,0c7.022-7.26,12.99-13.193,21.621-12.992V1260.344z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#484666"
    },
    d: "M39.985,1020.36c-13.165,0-23.984,10.816-23.984,23.975c0,13.16,10.82,24.094,23.984,24.094 s23.984-10.934,23.984-24.094C63.97,1031.176,53.15,1020.36,39.985,1020.36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93CFEF"
    },
    d: "M39.985,1036.422c4.515,0,7.916,3.398,7.916,7.912c0,4.512-3.402,8.031-7.916,8.031 c-4.515,0-8.034-3.52-8.034-8.031C31.951,1039.825,35.471,1036.422,39.985,1036.422z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#484666"
    },
    d: "M296.016,1020.36c-13.165,0-23.984,10.816-23.984,23.975c0,13.16,10.82,24.094,23.984,24.094 c13.164,0,23.984-10.934,23.984-24.094C320.001,1031.176,309.181,1020.36,296.016,1020.36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93CFEF"
    },
    d: "M296.016,1036.422c4.515,0,8.034,3.398,8.034,7.912c0,4.512-3.52,8.031-8.034,8.031 c-4.515,0-8.034-3.52-8.034-8.031C287.982,1039.825,291.502,1036.422,296.016,1036.422z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#64A5DA"
    },
    d: "M296.001,1036.413c-0.884,0-1.681,0.24-2.47,0.48c3.24,0.992,5.564,3.803,5.564,7.438 c0,3.627-2.324,6.5-5.564,7.529c0.788,0.24,1.586,0.48,2.47,0.48c4.515,0,8.034-3.52,8.034-8.031c0-4.518-3.519-7.936-8.034-7.936 V1036.413z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#64A5DA"
    },
    d: "M287.982,1092.422c-0.884,0-1.681,0.24-2.47,0.48c3.24,0.992,5.564,3.803,5.564,7.438 c0,3.627-2.324,6.5-5.564,7.531c0.788,0.24,1.586,0.48,2.47,0.48c4.515,0,8.034-3.52,8.034-8.031c0-4.518-3.519-7.938-8.034-7.938 V1092.422z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#64A5DA"
    },
    d: "M263.998,1140.432c-0.884,0-1.681,0.24-2.47,0.48c3.24,0.992,5.564,3.803,5.564,7.438 c0,3.629-2.324,6.5-5.564,7.531c0.788,0.24,1.586,0.48,2.47,0.48c4.515,0,8.034-3.518,8.034-8.031 c0-4.518-3.519-7.936-8.034-7.936V1140.432z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#64A5DA"
    },
    d: "M223.945,1180.411c-0.884,0-1.681,0.24-2.47,0.48c3.24,0.992,5.564,3.803,5.564,7.438 c0,3.629-2.324,6.5-5.564,7.531c0.788,0.24,1.586,0.48,2.47,0.48c4.515,0,8.034-3.518,8.034-8.031 c0-4.518-3.519-7.938-8.034-7.938V1180.411z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#64A5DA"
    },
    d: "M167.942,1204.444c-0.884,0-1.681,0.24-2.47,0.48c3.24,0.992,5.564,3.803,5.564,7.438 c0,3.629-2.324,6.5-5.564,7.531c0.788,0.24,1.586,0.48,2.47,0.48c4.515,0,8.034-3.518,8.034-8.031 c0-4.518-3.519-7.936-8.034-7.936L167.942,1204.444z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#64A5DA"
    },
    d: "M111.939,1180.411c-0.884,0-1.681,0.24-2.47,0.48c3.24,0.992,5.564,3.803,5.564,7.438 c0,3.629-2.324,6.5-5.564,7.531c0.788,0.24,1.586,0.48,2.47,0.48c4.515,0,8.034-3.518,8.034-8.031 c0-4.518-3.519-7.938-8.034-7.938V1180.411z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#64A5DA"
    },
    d: "M71.886,1140.432c-0.884,0-1.681,0.24-2.47,0.48c3.24,0.992,5.564,3.803,5.564,7.438 c0,3.629-2.324,6.5-5.564,7.531c0.788,0.24,1.586,0.48,2.47,0.48c4.515,0,8.034-3.518,8.034-8.031 c0-4.518-3.519-7.936-8.034-7.936V1140.432z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#64A5DA"
    },
    d: "M47.901,1092.422c-0.884,0-1.681,0.24-2.47,0.48c3.24,0.992,5.564,3.803,5.564,7.438 c0,3.627-2.324,6.5-5.564,7.531c0.788,0.24,1.586,0.48,2.47,0.48c4.515,0,8.034-3.52,8.034-8.031c0-4.518-3.519-7.938-8.034-7.938 V1092.422z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#64A5DA"
    },
    d: "M39.867,1036.413c-0.884,0-1.681,0.24-2.47,0.48c3.24,0.992,5.564,3.803,5.564,7.438 c0,3.627-2.324,6.5-5.564,7.529c0.788,0.24,1.586,0.48,2.47,0.48c4.515,0,8.034-3.52,8.034-8.031c0-4.518-3.519-7.936-8.034-7.936 L39.867,1036.413z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BD5858"
    },
    d: "M195.936,1260.337c-1.323,0.014-2.679,0.287-4.033,0.688c9.413,1.65,16.327,8.967,16.318,17.967 c-0.007,4.924-2.908,11.059-6.752,17.031c-5.206,8.088-17.015,20.184-27.29,29.623c-5.441,4.998-7.528,6.66-10.066,8.781 c0.995,0.816,3.093,2.705,3.939,3.404c3.044-2.523,6.399-5.256,13.942-12.186c10.275-9.439,22.084-21.535,27.29-29.623 c3.844-5.971,6.745-12.107,6.752-17.031c0.01-10.176-8.622-18.664-19.975-18.654H195.936z M140.042,1260.497 c-1.312,0.002-2.425,0.465-3.657,0.688c8.787,2.615,17.475,12.188,17.475,12.188c2.43,3.117,6.773,3.992,10.222,2.063 c-0.932-0.52-1.75-1.221-2.407-2.063C161.675,1273.372,149.999,1260.489,140.042,1260.497z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNecklace);
export default __webpack_public_path__ + "static/media/necklace.b0cfe2a05002c9e74db496613c2ce67a.svg";
export { ForwardRef as ReactComponent };